export default __webpack_public_path__ + "static/white-harbour-logo-ad4e53609e84f6f96118a9c8b670a781.png";